export class BasicAircraftDetails {
  public acicaocode: string;
  public Registration: string;
  public registerCountryPrefix: any;
  public crewcapacity: number;
  public paxcapacity: number;
  public WeightUnit: string = 'KG';
  public SESpeed: number;
  public SEDistance: string = '';
  public NCM: string;
  public from: string;
  public showFrom: string;
  public ManufacturerID: number;
  public ManufacturerName: string;
  public flag: number;
  public DTRowId: number;
  public ID: number;
  public AircraftICAOId: string;
  public AircraftType: string;
  public WakeTurbulanceCategory: string;
  public FuelType: string;
  public EngineName: string;
  public MaxflightlevelUnit: string = 'Feet';
  public operation: string = 'Private';
  public aircraftCategory: string = 'NarrowBody';
  public operationtype: string;
  public ATCFlightRule: string = 'IFR';
  public opsregulation: string;
  public noisecategory: string;
  public etopsenabled: string = 'yes';
  public SETime: number;
  public Maxflightlevel: string;
  public maxFuelValue: string;
  public ICAOCode: string;
  public Id: string;
  public MakeName: string;
  public ModelName: string;
  public UUID: string;
  public VariantName: string;
  public registration = '';
  public lengthSpanWeightRange: number;
  public minimumRunwayLength: number;
  public charterOption?: string = 'no';
  public actionItems?: string = 'Yes';
  // public netCharterRate: number;
  // public netCharterCurUnit: any;
  public taxiTime: number;
  // public multipleDates: string[] = [];
  constructor() {
    this.Registration =
      this.Registration != undefined
        ? this.Registration.toUpperCase()
        : this.Registration;
  }
}

export class ManufacturerNameList {
  public GetAircraftTypes: BasicAircraftDetails[];
}
export class FuelAircraftDetails {
  public maxfuelcapacity: number;
  public minalternatefuel: string;
  public depttaxifuel: number;
  public minresfuel: number;
  public FuelTank: number;
  public FuelUnit: string = 'Pound';
  public FuelType: string = 'JET A1';
  public FuelingType: string = 'pressure';
  public Carbonoffset: string = 'yes';
  public contigency: string;
  public HoldTime: string;
  public MinContingency: string;
  public fuelbias: string;
}

export class WeightsAircraftDetails {
  public basicoperationweight: any;
  public MZFW: any;
  public MLW: any;
  public MTOW: any;
  public MRW: any;
  public checkTabData: boolean = false;
  public taxiammount: number;
  public drymass: number;
  public lengthSpanWeightRange: number;
  // for firebase set data
  public WeightUnit: string = 'Pound';
}

export class EquipmentAircraftDetails {
  public NumberOfRafts: number;
  public RaftsCapacity: number;
  public RaftsColor: string;
  public RaftsCovered: string = 'yes';
  public ACFTColor: string;
  public SELCALCode: string;

  public LifeJacketEquipment = [];
  public equipmentArrEmergencyRadios = [];
  public equipmentArrSurvivalGear = [];
}

export class AvionicsAircraftDetails {
  public DEPT: string;
  public ARRV: string;
  public ERNP: string;
  public RTCAAddressCode: string;
  public TCAS: string;
  public GPSreceiver: string;
  // get from firebase for set data
  public equipmentArrCertification = [];
  public SSR = [];
  public Surveillencedependent = [];
  public performanceNavigation = [];
  public UplinkCapabilities: string;
  public navigatewithGPS: string;
  public ReportType: string;
  public Mask: string;
}

export class AircraftAttach {
  public FileName: string = '';
}
export class NoiseCertificates {
  public aoc: any = [];
  public coa: any = [];
  public cr: any = [];
  public ci: any = [];
  public nc: any = [];
}
export class NoiceAttachmentName {
  public AOCFileName: string = '';
  public VCOAFileName: string = '';
  public CORFileName: string = '';
  public CIOFileName: string = '';
  public NCFileName: string = '';
}
export class NoiceFile {
  public COIFile: Fileitems[] = [];
  public COAFile: Fileitems[] = [];
  public CORFile: Fileitems[] = [];
  public NCFile: Fileitems[] = [];
  public AOCFile: Fileitems[] = [];
}
export class UploadAircraft {
  public FileData: Fileitems[] = [];
}
export class Fileitems {
  public Name: string = '';
  public id?: any;
  public UploadName: string;
  public file?: any;
  public DownloadURl: any;
}
export class UploadAircraftExtImage {
  public ExteriorFileData: ExteriorFileImage;
  constructor() {
    // Initialize nested objects
    this.ExteriorFileData = new ExteriorFileImage();
  }
}
export class ExteriorFileImage {
  public Name: string = '';
  public id?: any;
  public UploadName: string;
  public file?: any;
  public DownloadURl:string = '';
  public UploadedURL?:string = '';
}
export class UploadAircraftIntImage {
  public InteriorFileData: InteriorFileImage[] =[];
  constructor() {
    this.InteriorFileData = [new InteriorFileImage()]
  }
}
export class InteriorFileImage {
  public Name: string = '';
  public id?: any;
  public UploadName: string;
  public file?: any;
  public DownloadURl: any;
  public UploadImgURL: any;
}
export class UploadAircraftSeatingImage {
  public seatingFileData: SeatingFileImage;
  constructor() {
    this.seatingFileData = new SeatingFileImage();
  }
}
export class SeatingFileImage {
  public Name: string = '';
  public id?: any;
  public UploadName: string;
  public file?: any;
  public DownloadURl:string = '';
}
export class Manufacturer {
  public GetAircraftTypes: ManufactureName[];
}
export class ManufactureName {
  public makename: string;
}
export class CharterRules {
  public emptyLeg:number;
  public servicesIncluded:any[] = ['3'];
  public servicesIncCost = [];
  public netCharter: number;
  public netCharterCurUnit: any;
  public brokerageType: string = 'Fixed';
  public brokerageCost: number;
  public multipleDates: string[] = [];
  public listOfCountries: any;
  public insurancePremium: any;
  public notes: string = '';
  public termsAndCondition: string = '';
  public aircraftRange: string = null;
  public yearOfManufacturer: string = '';
  public yearOfRefurbishment: string = '';
  public flightCategory: string = '';
  public aircraftRangeUnit: string = 'NM';
  public cruiseSpeed: string = '';
  public baggage: string = '';
  public cabinWidth: string = '';
  public cabinHeight:string = '';
  public cabinLength: string = '';
  public flightAttendent: string = 'NO';
  public facilities:string = 'None';
  public Wifi: string = 'Not Available';
  public CrewBLT: number;
  public RetentionCharges: number;
  constructor(data?:CharterRulesData) {
    if (data) {
      // Handle numeric values more safely
      this.emptyLeg = data.emptyLeg ? Number(data.emptyLeg) : null;
      this.brokerageCost = data.brokerageCost ? Number(data.brokerageCost) : null;
      this.netCharter = data.netCharter ? Number(data.netCharter) : null;

      // Handle string and array values
      this.servicesIncluded = data.servicesIncluded || ['3'];
      this.multipleDates = data.multipleDates || [];
      this.notes = data.notes || '';
      this.termsAndCondition = data.termsAndCondition || '';
      this.yearOfManufacturer = data.yearOfManufacturer || '';
      this.yearOfRefurbishment = data.yearOfRefurbishment || '';
      this.flightCategory = data.flightCategory || '';
      this.brokerageType = data.brokerageType || 'Fixed';
      this.aircraftRange = data.aircraftRange ? data.aircraftRange.replace(/NM$/, '').trim() :null;
      this.aircraftRangeUnit = data.aircraftRangeUnit || 'NM';
      this.cruiseSpeed = data?.cruiseSpeed || '';
      this.baggage = data?.baggage || '';
      this.cabinHeight = data?.cabinHeight || '';
      this.cabinLength = data?.cabinLength || '';
      this.cabinWidth = data?.cabinWidth || '';
      this.flightAttendent = data?.flightAttendent || 'NO';
      this.facilities = data?.facilities || 'None';
      this.Wifi = data?.Wifi || 'Not Available';
      this.CrewBLT = data?.CrewBLT || null;
      this.RetentionCharges = data?.RetentionCharges || null;
    }
  }
}

export interface CharterRulesData {
aircraftRange: string;
brokerageCost: string | number;
brokerageType: string;
emptyLeg: string | number;
flightCategory: string;
multipleDates: string[]
netCharter: string;
servicesIncluded:any[];
notes: string;
termsAndCondition:string;
yearOfManufacturer:string;
yearOfRefurbishment:string;
aircraftRangeUnit: string;
cruiseSpeed: string;
cabinHeight: string;
cabinLength: string;
cabinWidth: string;
baggage: string;
flightAttendent: string;
facilities: string;
Wifi: string;
CrewBLT: number;
RetentionCharges: number;
}
